import Tooltip from './tooltip';
export { default as Tooltip } from './tooltip';
import Icon from './icon';
export { default as Icon } from './icon';
import Mask from './mask';
export { default as Mask } from './mask';
import Popup from './popup';
export { default as Popup } from './popup';
import Button from './button';
export { default as Button } from './button';
import Loading from './loading';
export { default as Loading } from './loading';
import Scroll from './scroll';
export { default as Scroll } from './scroll';
import Transition from './transition';
export { default as Transition } from './transition';
import Badge from './badge';
export { default as Badge } from './badge';
import Switch from './switch';
export { default as Switch } from './switch';
import Checkbox from './checkbox';
export { default as Checkbox } from './checkbox';
import CheckboxGroup from './checkbox-group';
export { default as CheckboxGroup } from './checkbox-group';
import Radio from './radio';
export { default as Radio } from './radio';
import RadioGroup from './radio-group';
export { default as RadioGroup } from './radio-group';
import NoticeBar from './notice-bar';
export { default as NoticeBar } from './notice-bar';
import Dialog from './dialog';
export { default as Dialog } from './dialog';
import Toast from './toast';
export { default as Toast } from './toast';
import Swiper from './swiper';
export { default as Swiper } from './swiper';
import ActivityIndicator from './activity-indicator';
export { default as ActivityIndicator } from './activity-indicator';
import EmptyState from './empty-state';
export { default as EmptyState } from './empty-state';
import Picker from './picker';
export { default as Picker } from './picker';
import Uploader from './uploader';
export { default as Uploader } from './uploader';
import Input from './input';
export { default as Input } from './input';
import FormItem from './form-item';
export { default as FormItem } from './form-item';
import DateTimePicker from './date-time-picker';
export { default as DateTimePicker } from './date-time-picker';
import ActionSheet from './action-sheet';
export { default as ActionSheet } from './action-sheet';
import NavBar from './nav-bar';
export { default as NavBar } from './nav-bar';
import Textarea from './textarea';
export { default as Textarea } from './textarea';
import ImagePreview from './image-preview';
export { default as ImagePreview } from './image-preview';
import Stepper from './stepper';
export { default as Stepper } from './stepper';
import BottomPanel from './bottom-panel';
export { default as BottomPanel } from './bottom-panel';
import BottomDialog from './bottom-dialog';
export { default as BottomDialog } from './bottom-dialog';
import SwipeCell from './swipe-cell';
export { default as SwipeCell } from './swipe-cell';
import TabPanel from './tab-panel';
export { default as TabPanel } from './tab-panel';
import Tabs from './tabs';
export { default as Tabs } from './tabs';
import Sticky from './sticky';
export { default as Sticky } from './sticky';
import Avatar from './avatar';
export { default as Avatar } from './avatar';
import Popover from './popover';
export { default as Popover } from './popover';
import Snackbar from './snackbar';
export { default as Snackbar } from './snackbar';
import ConfigProvider from './config-provider';
export { default as ConfigProvider } from './config-provider';
export { autoTheme, switchTheme } from './utils/theme';

// import { PluginFunction } from 'vue';
var components = [Tooltip, Icon, Mask, Popup, Button, Loading, Scroll, Transition, Badge, Switch, Checkbox, CheckboxGroup, Radio, RadioGroup, NoticeBar, Dialog, Toast, Swiper, ActivityIndicator, EmptyState, Picker, Uploader, Input, FormItem, DateTimePicker, ActionSheet, NavBar, Textarea, ImagePreview, Stepper, BottomPanel, BottomDialog, SwipeCell, TabPanel, Tabs, Sticky, Avatar, Popover, Snackbar, ConfigProvider];
var install = function install(Vue) {
  components.forEach(function (component) {
    Vue.component(component.name, component);
  });
};

export { install as default };
